export const adapterDayDescription = (dayId) => {
    const days = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"];

    return days[dayId - 1];
};
